module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_COND.a99e4144.png";